/**
 * Get the max runs that are defaulted in the panels
 * If a user can use the custom default, return that value
 */
export const DEFAULT_NUM_RUNS_OLD = 10; // legacy setting
export const DEFAULT_NUM_RUNS_NEW = 30; // new workspace config feature defaults to 30
export const DEFAULT_MAX_NUM_RUNS = 300; // users cannot set max runs higher than this value
export const DEFAULT_MAX_GROUP_RUNS = 100;
